/**
* 门店管理 店铺管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>店铺管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" ref="formRef">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="店铺名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" placeholder="管理手机号"></el-input>
      </el-form-item>

      <el-form-item>
        <el-select size="small" v-model="formInline.shopType" placeholder="请选择">
          <el-option v-for="type in shopType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select size="small" v-model="formInline.status" placeholder="请选择">
          <el-option v-for="type in shopStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="info" icon="el-icon-refresh" native-type="reset" @click="resetForm">重置
        </el-button>
        <el-button size="small" type="success" icon="el-icon-circle-plus-outline" @click="add">新增店铺</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="店铺ID" width="90" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="name" label="店铺名称" width="150" show-overflow-tooltip>
        <!-- 修改：添加点击事件 -->
        <template slot-scope="scope">
          <span class="clickable-name" @click="showShopDetail(scope.row)">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="mobile" label="管理手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="ratio" label="手续费" width="90" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="status_txt" label="店铺状态" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag
            :type="getStatusTag(scope.row.status_txt)"
            :disable-transitions="false"
          >
            {{ scope.row.status_txt }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="店铺状态" show-overflow-tooltip v-if="false">
        <!--        不在列表展示-->
      </el-table-column>
      <el-table-column sortable prop="shop_type" label="店铺类型" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag
            :type="getTypeTag(scope.row.shop_type)"
            :disable-transitions="false"
          >
            {{ scope.row.shop_type }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="city" label="所属城市" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="tel" label="客服电话" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="agent_mobile" label="代理手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="address" label="地址" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="mt_time_txt" label="美团截止有效期" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="poi_id" label="抖音" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 新增界面 -->
    <el-dialog title="新增店铺" :visible.sync="addFormVisible" width="40%" @click="closeDialog('addForm')">
      <el-form label-width="120px" :model="addForm" ref="addForm" :rules="addFormRules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="店铺名称" prop="name">
              <el-input size="small" v-model="addForm.name" auto-complete="off"
                        placeholder="请输入商铺名称"></el-input>
            </el-form-item>

            <el-form-item label="手机号" prop="mobile">
              <el-input size="small" v-model="addForm.mobile" auto-complete="off"
                        placeholder="请输入手机号"></el-input>
            </el-form-item>

            <el-form-item label="手续费(%)" prop="ratio">
              <el-input size="small" v-model="addForm.ratio" auto-complete="off"
                        placeholder="请输入手续费值"></el-input>
            </el-form-item>

            <el-form-item label="店铺类型">
              <el-select size="small" v-model="addForm.shop_type" placeholder="请选择">
                <el-option v-for="type in shopType" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="美团名称">
              <el-input size="small" v-model="addForm.mt_name" auto-complete="off"
                        placeholder="请输入美团名称"></el-input>
            </el-form-item>

            <el-form-item label="抖音主ID">
              <el-input size="small" v-model="addForm.dou_id" auto-complete="off"
                        placeholder="请输入抖音主ID"></el-input>
            </el-form-item>
            <el-form-item label="抖音子Id">
              <el-input size="small" v-model="addForm.poi_id" auto-complete="off"
                        placeholder="请输入抖音子ID"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="addSubmitForm">添加</el-button>
              <el-button size="small" type="info" icon="el-icon-refresh" native-type="reset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="editFormRules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="店铺id">
              <el-input size="small" v-model="editForm.id" auto-complete="off" placeholder="请输入ID"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="店铺名称" prop="name">
              <el-input size="small" v-model="editForm.name" auto-complete="off"
                        placeholder="请输入商铺名称"></el-input>
            </el-form-item>
            <el-form-item label="手续费(%)" prop="ratio">
              <el-input size="small" v-model="editForm.ratio" auto-complete="off"
                        placeholder="请输入手续费值"></el-input>
            </el-form-item>

            <el-form-item label="店铺类型">
              <el-select size="small" v-model="editForm.shop_type" placeholder="请选择">
                <el-option v-for="type in shopType" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="店铺状态">
              <el-select size="small" v-model="editForm.status" placeholder="请选择">
                <el-option v-for="type in shopStatus" :label="type.key" :value="type.value"
                           :key="type.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所属城市">
              <el-input size="small" v-model="editForm.city" auto-complete="off" placeholder="请输入所属城市"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="美团名称">
              <el-input size="small" v-model="editForm.mt_name" auto-complete="off"
                        placeholder="请输入美团名称"></el-input>
            </el-form-item>

            <el-form-item label="手机号" prop="mobile">
              <el-input size="small" v-model="editForm.mobile" auto-complete="off"
                        placeholder="请输入手机号"></el-input>
            </el-form-item>

            <el-form-item label="抖音主ID">
              <el-input size="small" v-model="editForm.dou_id" auto-complete="off"
                        placeholder="请输入抖音主ID"></el-input>
            </el-form-item>
            <el-form-item label="抖音子Id">
              <el-input size="small" v-model="editForm.poi_id" auto-complete="off"
                        placeholder="请输入抖音子ID"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="editSubmitForm">提交</el-button>
              <el-button size="small" type="info" icon="el-icon-refresh" native-type="reset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 详情界面 -->
    <el-dialog
      :title="currentShop ? currentShop.name + ' 详情' : '店铺详情'"
      :visible.sync="shopDetailVisible"
      width="80%"
      :before-close="handleDetailClose"
      custom-class="shop-detail-dialog">
      
      <!-- 店铺信息卡片 -->
      <div class="shop-info-card" v-if="currentShop">
        <div class="shop-header">
          <div class="shop-avatar">
            <i class="el-icon-s-shop"></i>
          </div>
          <div class="shop-title">
            <h2>{{ currentShop.name }}</h2>
            <el-tag :type="getStatusTag(currentShop.status_txt)" size="medium">
              {{ currentShop.status_txt }}
            </el-tag>
            <el-tag :type="getTypeTag(currentShop.shop_type)" size="medium" style="margin-left: 8px;">
              {{ currentShop.shop_type }}
            </el-tag>
          </div>
        </div>
        
        <div class="shop-info-grid">

          <div class="info-item">
            <i class="el-icon-time"></i>
            <span class="label">店铺ID</span>
            <span class="value">{{ currentShop.id || '-' }}</span>
          </div>
          <div class="info-item">
            <i class="el-icon-mobile-phone"></i>
            <span class="label">管理手机</span>
            <span class="value">{{ currentShop.mobile || '-' }}</span>
          </div>
          <div class="info-item">
            <i class="el-icon-office-building"></i>
            <span class="label">详细地址</span>
            <el-tooltip 
              :content="currentShop.address || '-'" 
              placement="top" 
              :disabled="!currentShop.address || currentShop.address.length <= 20"
              effect="dark">
              <span class="value address-value single-line">
                {{ currentShop.address || '-' }}
              </span>
            </el-tooltip>
          </div>
          <div class="info-item">
            <i class="el-icon-coin"></i>
            <span class="label">手续费</span>
            <span class="value">{{ currentShop.ratio || '0' }}%</span>
          </div>
        </div>
      </div>

      <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabChange" class="detail-tabs" lazy>
        
        <!-- <el-tab-pane label="📊 概览" name="overview">
          <div class="tab-content overview-content">
            <div class="stats-grid">
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="el-icon-s-home"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ deviceList.length || 0 }}</div>
                  <div class="stat-label">包厢数量</div>
                </div>
              </div>
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="el-icon-s-grid"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ tableList.length || 0 }}</div>
                  <div class="stat-label">台桌数量</div>
                </div>
              </div>
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="el-icon-s-custom"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ staffList.length || 0 }}</div>
                  <div class="stat-label">员工数量</div>
                </div>
              </div>
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="el-icon-s-ticket"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-number">{{ meituanList.length + douyinList.length + groupList.length || 0 }}</div>
                  <div class="stat-label">优惠券总数</div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane> -->
        
        <el-tab-pane label="🎪 包厢管理" name="device">
          <div class="tab-content">
            <!-- <div class="table-header">
              <h3>包厢设备列表</h3>
              <p class="table-desc">管理店铺内所有包厢及其设备状态</p>
            </div> -->
            <el-table :data="deviceList" border v-loading="loading" 
                      class="modern-table"
                      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
              <el-table-column prop="name" label="包厢名称" min-width="120"></el-table-column>
              <el-table-column prop="device_sn" label="设备编号" min-width="140"></el-table-column>
              <el-table-column prop="d_status_txt" label="设备状态" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.d_status_txt === '在线' ? 'success' : 'danger'" size="small">
                    {{ scope.row.d_status_txt }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="heart_time" label="最后响应" min-width="140"></el-table-column>
              <el-table-column prop="sim" label="SIM卡号" min-width="120"></el-table-column>
              <el-table-column prop="status_txt" label="包厢状态" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status_txt === '启用' ? 'success' : 'info'" size="small">
                    {{ scope.row.status_txt }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="roomPage" @callFather="roomPaging"></Pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="🎯 台桌管理" name="table">
          <div class="tab-content">
            <!-- <div class="table-header">
              <h3>台桌设备列表</h3>
              <p class="table-desc">管理店铺内所有台桌及其设备配置</p>
            </div> -->
            <el-table :data="tableList" border v-loading="loading" 
                      class="modern-table"
                      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
              <el-table-column prop="id" label="台桌ID" width="80" align="center"></el-table-column>
              <el-table-column prop="name" label="台桌名称" min-width="120"></el-table-column>
              <el-table-column prop="device_sn" label="设备编号" min-width="140"></el-table-column>
              <el-table-column prop="status_txt" label="台桌状态" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status_txt === '启用' ? 'success' : 'info'" size="small">
                    {{ scope.row.status_txt }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="d_status_txt" label="设备状态" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.d_status_txt === '在线' ? 'success' : 'danger'" size="small">
                    {{ scope.row.d_status_txt }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="heart_time" label="最后响应" min-width="140"></el-table-column>
              <el-table-column prop="min_amount" label="最低金额" width="100" align="right">
                <template slot-scope="scope">
                  <span class="amount">¥{{ scope.row.min_amount || '0' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ya_amount" label="台桌押金" width="100" align="right">
                <template slot-scope="scope">
                  <span class="amount">¥{{ scope.row.ya_amount || '0' }}</span>
                </template>
              </el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="tablePage" @callFather="tablePaging"></Pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="👥 员工管理" name="staff">
          <div class="tab-content">
            <!-- <div class="table-header">
              <h3>员工列表</h3>
              <p class="table-desc">管理店铺内所有员工信息</p>
            </div> -->
            <el-table :data="staffList" border v-loading="loading" 
                      class="modern-table" height="500"
                      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
              <el-table-column prop="id" label="员工ID" width="80" align="center"></el-table-column>
              <el-table-column prop="username" label="姓名" min-width="120"></el-table-column>
              <el-table-column prop="role" label="职位" width="120" align="center">
                <template slot-scope="scope">
                  <el-tag type="primary" size="small">{{ scope.row.role || '-' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="mobile" label="手机号" min-width="120"></el-table-column>
              <el-table-column prop="create_time_txt" label="添加时间" min-width="160"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="🎫 美团券" name="meituan">
          <div class="tab-content">
            <el-table :data="meituanList" border element-loading-text="拼命加载中" v-loading="loading" height="500">
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column prop="id" label="券ID" width="80"></el-table-column>
              <el-table-column prop="title" label="券名称"></el-table-column>
              <el-table-column prop="price" label="价格" width="100"></el-table-column>
              <el-table-column prop="rooms" label="所属包厢">
                <template slot-scope="scope" class="el-other">
                  <div class="tag-container" v-if="scope.row.rooms && scope.row.rooms.length">
                    <el-tag
                      v-for="(room, index) in scope.row.rooms"
                      :key="index"
                      type="primary"
                      size="small"
                      style="margin-right: 4px;"
                      class="tag-item"
                      :class="{ 'hidden-tag': scope.row.rooms.length > 3 && index >= 3 }"
                    >
                      {{ room }}
                    </el-tag>

                    <!-- 显示省略计数 -->
                    <el-tag
                      v-if="scope.row.rooms.length > 3"
                      type="info"
                      size="small"
                      class="more-tag"
                    >
                      +{{ scope.row.rooms.length - 3 }}
                    </el-tag>
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop="weeks" label="适用星期">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(week, index) in scope.row.weeks"
                    :key="index"
                    type="success"
                    size="small"
                    style="margin-right: 4px;"
                  >
                    {{ week }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="use_time" label="适用时间段"></el-table-column>
              <el-table-column prop="type_txt" label="券类型" width="100"></el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="mtPage" @callFather="mtPaging"></Pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="🎵 抖音券" name="douyin">
          <div class="tab-content">
            <el-table :data="douyinList" border element-loading-text="拼命加载中" v-loading="loading" height="500">
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column prop="id" label="券ID" width="80"></el-table-column>
              <el-table-column prop="sku_name" label="券名称"></el-table-column>
              <el-table-column prop="price" label="价格" width="80"></el-table-column>

              <el-table-column prop="rooms" label="所属包厢">
                <template slot-scope="scope" class="el-other">
                  <div class="tag-container" v-if="scope.row.rooms && scope.row.rooms.length">
                    <el-tag
                      v-for="(room, index) in scope.row.rooms"
                      :key="index"
                      type="primary"
                      size="small"
                      style="margin-right: 4px;"
                      class="tag-item"
                      :class="{ 'hidden-tag': scope.row.rooms.length > 3 && index >= 3 }"
                    >
                      {{ room }}
                    </el-tag>

                    <!-- 显示省略计数 -->
                    <el-tag
                      v-if="scope.row.rooms.length > 3"
                      type="info"
                      size="small"
                      class="more-tag"
                    >
                      +{{ scope.row.rooms.length - 3 }}
                    </el-tag>
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop="weeks" label="适用星期">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(week, index) in scope.row.weeks"
                    :key="index"
                    type="success"
                    size="small"
                    style="margin-right: 4px;"
                  >
                    {{ week }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="use_time" label="适用时间段"></el-table-column>
              <el-table-column prop="type_txt" label="类型" width="80"></el-table-column>

            </el-table>
            <Pagination v-bind:child-msg="douPage" @callFather="douPaging"></Pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="🛒 团购券" name="group">
          <div class="tab-content">
            <el-table :data="groupList" border element-loading-text="拼命加载中" v-loading="loading" height="500">
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column prop="id" label="券ID" width="80"></el-table-column>
              <el-table-column prop="name" label="券名称"></el-table-column>
              <el-table-column prop="price" label="价格" width="80"></el-table-column>

              <el-table-column prop="rooms" label="所属包厢">
                <template slot-scope="scope" class="el-other">
                  <div class="tag-container" v-if="scope.row.rooms && scope.row.rooms.length">
                    <el-tag
                      v-for="(room, index) in scope.row.rooms"
                      :key="index"
                      type="primary"
                      size="small"
                      style="margin-right: 4px;"
                      class="tag-item"
                      :class="{ 'hidden-tag': scope.row.rooms.length > 3 && index >= 3 }"
                    >
                      {{ room }}
                    </el-tag>

                    <!-- 显示省略计数 -->
                    <el-tag
                      v-if="scope.row.rooms.length > 3"
                      type="info"
                      size="small"
                      class="more-tag"
                    >
                      +{{ scope.row.rooms.length - 3 }}
                    </el-tag>
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop="weeks" label="适用星期">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(week, index) in scope.row.weeks"
                    :key="index"
                    type="success"
                    size="small"
                    style="margin-right: 4px;"
                  >
                    {{ week }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="valid_day" label="有效天数" width="80"></el-table-column>
              <el-table-column prop="status_txt" label="状态" width="80"></el-table-column>
              <el-table-column prop="is_max_buy" label="购买数量" width="100"></el-table-column>
              <el-table-column prop="create_time_txt" label="创建时间"></el-table-column>

            </el-table>
            <Pagination v-bind:child-msg="tuanPage" @callFather="tuanPaging"></Pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="优惠券管理" name="coupon">
          <div class="tab-content">
            <el-table :data="couponList" border element-loading-text="拼命加载中" v-loading="loading" height="500">
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column prop="id" label="券ID" width="80"></el-table-column>
              <el-table-column prop="name" label="券名称"></el-table-column>

              <el-table-column prop="rooms" label="所属包厢">
                <template slot-scope="scope" class="el-other">
                  <div class="tag-container" v-if="scope.row.rooms && scope.row.rooms.length">
                    <el-tag
                      v-for="(room, index) in scope.row.rooms"
                      :key="index"
                      type="primary"
                      size="small"
                      style="margin-right: 4px;"
                      class="tag-item"
                      :class="{ 'hidden-tag': scope.row.rooms.length > 3 && index >= 3 }"
                    >
                      {{ room }}
                    </el-tag>

                    <!-- 显示省略计数 -->
                    <el-tag
                      v-if="scope.row.rooms.length > 3"
                      type="info"
                      size="small"
                      class="more-tag"
                    >
                      +{{ scope.row.rooms.length - 3 }}
                    </el-tag>
                  </div>

                </template>
              </el-table-column>
              <el-table-column prop="weeks" label="适用星期">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(week, index) in scope.row.weeks"
                    :key="index"
                    type="success"
                    size="small"
                    style="margin-right: 4px;"
                  >
                    {{ week }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="80"></el-table-column>
              <el-table-column prop="amount" label="抵扣金额" width="80"></el-table-column>
              <el-table-column prop="order_amount" label="订单金额" width="80"></el-table-column>
              <el-table-column prop="use_time" label="适用时间段"></el-table-column>
              <el-table-column prop="valid_day" label="有效天数" width="80"></el-table-column>
              <el-table-column prop="max_count" label="最大购买数量" width="80"></el-table-column>
              <el-table-column prop="create_time_txt" label="创建时间"></el-table-column>

            </el-table>
            <Pagination v-bind:child-msg="couponPage" @callFather="couponPaging"></Pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import {timestampToTime} from "../../utils/util";
import {coupon, dou, mt, roomDevice, shop, shopEmployee, tableDevice, tuan,addShop,editShop} from "../../api/shop";

export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      // 新增：店铺详情弹窗相关
      shopDetailVisible: false,
      currentShop: null,
      activeTab: 'device',
      shop_id: '',
      listData: [],
      tabLoading: {
        device: false,
        box: false,
        table: false,
        staff: false,
        meituan: false,
        douyin: false,
        group: false,
        coupon: false
      },
      shopType: [
        {key: '请选择', value: 0},
        {key: '棋牌', value: '棋牌'},
        {key: '台球', value: '台球'},
        {key: '棋牌台球', value: '棋牌台球'},
        {key: '台球棋牌', value: '台球棋牌'},
      ],
      shopStatus: [
        {key: '请选择', value: 0},
        {key: '试营业', value: 1},
        {key: '营业中', value: 2},
        {key: '筹备中', value: 3},
        {key: '休息中', value: 4},
        {key: '已闭店', value: -1},
      ],
      addForm: {
        id: '',
        name: '',
        mobile: '',
        ratio: 0,
        shop_type: '',
        mt_name: '',
        dou_id: '',
        poi_id: '',
        org_id: this.$globalConfig.orgId,
      },
      editForm: {
        id: '',
        name: '',
        mobile: '',
        ratio: 0,
        shop_type: '棋牌',
        status: 1,
        city: '',
        mt_name: '',
        dou_id: '',
        poi_id: '',

      },
      formInline: {
        page: 1,
        limit: 10,
        mobile: '',
        name: '',
        shopType: '棋牌',
        status: '',
        org_id: this.$globalConfig.orgId,
      },
      deviceList: [],
      tableList: [],
      staffList: [],
      meituanList: [],
      douyinList: [],
      groupList: [],
      couponList: [],

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      //包厢与设备
      roomPage: {
        id: '',
        page: 1,
        limit: 10,
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      //台桌与设备
      tablePage: {
        id: '',
        page: 1,
        limit: 10,
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      //员工管理
      employeePage: {
        id: '',
        page: 1,
        limit: 10,
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      //美团
      mtPage: {
        id: '',
        page: 1,
        limit: 10,
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      //抖音
      douPage: {
        id: '',
        page: 1,
        limit: 10,
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      //团购券
      tuanPage: {
        id: '',
        page: 1,
        limit: 10,
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      //优惠券
      couponPage: {
        id: '',
        page: 1,
        limit: 10,
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证规则
      addFormRules: {
        name: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        ratio: [
          { required: true, message: '请输入手续费', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的数值格式(最多两位小数)', trigger: 'blur' }
        ]
      },
      editFormRules: {
        name: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        ratio: [
          { required: true, message: '请输入手续费', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的数值格式(最多两位小数)', trigger: 'blur' }
        ]
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    getdata(parameter) {
      this.loading = true
      shop(parameter).then(res => {
        this.loading = false
        if (res.code !== 1) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.data
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.data.total
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },

    getStatusTag(status) {
      switch (status) {
        case '营业中':
          return 'success'
        case '休息中':
          return 'warning'
        case '筹备中':
          return 'danger'
        case '试营业':
          return 'info'
        case '部分退款':
          return 'info'
        default:
          return ''
      }
    },

    getTypeTag(status) {
      switch (status) {
        case '棋牌':
          return 'success'
        case '台球':
          return 'warning'
        case '棋牌台球':
          return 'danger'
        case '台球棋牌':
          return 'info'
        case '部分退款':
          return 'info'
        default:
          return ''
      }
    },

    //重置
    resetForm() {
      this.formInline.page = 1
      this.formInline.limit = 10
      this.formInline.mobile = ''
      this.formInline.name = ''
      this.formInline.status = ''
      this.formInline.shopType = ''
      this.getdata(this.formInline)
    },

    add() {
      this.addFormVisible = true;
      // 重置表单
      this.$refs.addForm && this.$refs.addForm.resetFields();
    },

    // ------分页事件------
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    roomPaging(param) {
      this.roomPage.page = param.currentPage
      this.roomPage.limit = param.pageSize
      this.loadDeviceList()
    },
    tablePaging(param) {
      this.tablePage.page = param.currentPage
      this.tablePage.limit = param.pageSize
      this.loadTableList()

    },
    employeePaging(param) {
      this.employeePage.page = param.currentPage
      this.employeePage.limit = param.pageSize
      this.loadStaffList()
    },
    mtPaging(param) {
      this.mtPage.page = param.currentPage
      this.mtPage.limit = param.pageSize
      this.loadMeituanList()
    },
    douPaging(param) {
      this.douPage.page = param.currentPage
      this.douPage.limit = param.pageSize
      this.loadDouyinList()
    },
    tuanPaging(param) {
      this.tuanPage.page = param.currentPage
      this.tuanPage.limit = param.pageSize
      this.loadGroupList()
    },
    couponPaging(param) {
      this.couponPage.page = param.currentPage
      this.couponPage.limit = param.pageSize
      this.loadCouponList()
    },

    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      this.editForm = Object.assign({}, row)
      
      // 根据status_txt获取对应的status数值，确保下拉框正确显示文本
      const statusMap = {
        '试营业': 1,
        '营业中': 2,
        '筹备中': 3,
        '休息中': 4,
        '已闭店': -1
      }
      
      // 如果row中有status_txt但没有status，或者status不匹配，则根据status_txt设置
      if (row.status_txt && statusMap[row.status_txt]) {
        this.editForm.status = statusMap[row.status_txt]
      } else {
        // 确保status是数值类型，以便与shopStatus中的value匹配
        if (typeof this.editForm.status === 'string') {
          this.editForm.status = parseInt(this.editForm.status)
        } else if (typeof this.editForm.status !== 'number') {
          // 处理其他情况，默认为1（试营业）
          this.editForm.status = 1
        }
      }
    },

    // 增加店铺页面保存方法
    addSubmitForm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.loading = true
          addShop(this.addForm)
            .then(res => {
              this.addFormVisible = false
              this.loading = false
              if (res.code == 1) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.$refs.addForm.resetFields();
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.addFormVisible = false
              this.loading = false
              this.$message.error('新增店铺失败')
            })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善表单信息'
          })
          return false
        }
      })
    },

    // 编辑页面保存方法
    editSubmitForm(editData) {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loading = true
          editShop(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 1) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('编辑店铺失败')
            })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善表单信息'
          })
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },

    // 新增：显示店铺详情弹窗
    showShopDetail(shop) {
      this.currentShop = {...shop};
      this.shopDetailVisible = true;
      this.activeTab = 'device'; // 默认显示设备管理
      this.shop_id = shop.id;
      // 加载默认选项卡数据
      this.loadDeviceList();
    },

    // 新增：处理选项卡切换
    handleTabChange(tab) {
      switch (tab.name) {
        case 'device':
          this.loadDeviceList();
          break;
        case 'table':
          this.loadTableList();
          break;
        case 'staff':
          this.loadStaffList();
          break;
        case 'meituan':
          this.loadMeituanList();
          break;
        case 'douyin':
          this.loadDouyinList();
          break;
        case 'group':
          this.loadGroupList();
          break;
        case 'coupon':
          this.loadCouponList();
          break;
      }
    },

    // 新增：关闭详情弹窗时重置数据
    handleDetailClose() {
      this.shopDetailVisible = false;
      this.currentShop = null;
      // 清空所有列表数据
      this.deviceList = [];
      this.tableList = [];
      this.staffList = [];
      this.meituanList = [];
      this.douyinList = [];
      this.groupList = [];
      this.couponList = [];
    },

    loadDeviceList() {
      this.loading = true
      this.roomPage.id = this.shop_id
      roomDevice(this.roomPage).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.deviceList = res.data.data;

          this.roomPage.currentPage = this.roomPage.page
          this.roomPage.pageSize = this.roomPage.limit
          this.roomPage.total = res.data.total
          this.$message({
            type: 'success',
            message: '查询成功！'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取信息失败')
      })
    },

    loadTableList() {
      this.loading = true
      this.tablePage.id = this.shop_id
      tableDevice(this.tablePage).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.tableList = res.data.data;

          this.tablePage.currentPage = this.tablePage.page
          this.tablePage.pageSize = this.tablePage.limit
          this.tablePage.total = res.data.total
          this.$message({
            type: 'success',
            message: '查询成功！'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取信息失败')
      })
    },

    loadStaffList() {
      this.loading = true
      this.employeePage.id = this.shop_id
      shopEmployee(this.employeePage).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.staffList = res.data.data;

          this.employeePage.currentPage = this.employeePage.page
          this.employeePage.pageSize = this.employeePage.limit
          this.employeePage.total = res.data.total
          this.$message({
            type: 'success',
            message: '查询成功！'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取信息失败')
      })
    },

    loadMeituanList() {
      this.loading = true
      this.mtPage.id = this.shop_id
      mt(this.mtPage).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.meituanList = res.data.data;

          this.mtPage.currentPage = this.mtPage.page
          this.mtPage.pageSize = this.mtPage.limit
          this.mtPage.total = res.data.total
          this.$message({
            type: 'success',
            message: '查询成功！'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取信息失败')
      })
    },

    loadDouyinList() {
      this.loading = true
      this.douPage.id = this.shop_id
      dou(this.douPage).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.douyinList = res.data.data;

          this.douPage.currentPage = this.douPage.page
          this.douPage.pageSize = this.douPage.limit
          this.douPage.total = res.data.total
          this.$message({
            type: 'success',
            message: '查询成功！'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取信息失败')
      })
    },

    loadGroupList() {
      this.loading = true
      this.tuanPage.id = this.shop_id
      tuan(this.tuanPage).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.groupList = res.data.data;

          this.tuanPage.currentPage = this.tuanPage.page
          this.tuanPage.pageSize = this.tuanPage.limit
          this.tuanPage.total = res.data.total
          this.$message({
            type: 'success',
            message: '查询成功！'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取信息失败')
      })
    },

    loadCouponList() {
      this.loading = true
      this.couponPage.id = this.shop_id
      coupon(this.couponPage).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.couponList = res.data.data;

          this.couponPage.currentPage = this.couponPage.page
          this.couponPage.pageSize = this.couponPage.limit
          this.couponPage.total = res.data.total
          this.$message({
            type: 'success',
            message: '查询成功！'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('获取信息失败')
      })
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

/* 新增：点击样式 */
.clickable-name {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
}

/* 新增：选项卡内容样式 */
.tab-content {
  margin-top: 1px;
}

::v-deep .el-tabs__content {
  margin-top: 15px;
}

.tag-item {
  margin-right: 4px;
}

/* 默认隐藏第4个之后的标签 */
.hidden-tag {
  display: none;
}

.tag-container {
  position: relative;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
}

/* 鼠标悬停时显示所有标签 */
.tag-container:hover .hidden-tag {
  display: inline-block;
}

/* 鼠标悬停时隐藏省略计数标签 */
.tag-container:hover .more-tag {
  display: none;
}

.more-tag {
  background-color: #f0f2f5;
  color: #606266;
  border-color: #e4e7ed;
}
</style>

<style scoped>
/* 店铺详情弹框样式 */
::v-deep .shop-detail-dialog {
  border-radius: 0;
  overflow: hidden;
  margin: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  position: fixed !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 75vw !important;
  height: 100vh !important;
  max-height: 100vh !important;
  display: flex;
  flex-direction: column;
  box-shadow: none;
}

::v-deep .shop-detail-dialog .el-dialog__body {
  padding: 0;
  flex: 1;
  overflow-y: auto;
  max-height: calc(100vh - 60px);
}

::v-deep .shop-detail-dialog .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 24px;
  margin: 0;
}

::v-deep .shop-detail-dialog .el-dialog__title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}

::v-deep .shop-detail-dialog .el-dialog__body {
  padding: 0;
}

/* 店铺信息卡片样式 */
.shop-info-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.shop-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.shop-avatar {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.shop-avatar i {
  font-size: 28px;
  color: white;
}

.shop-title h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}

.shop-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  background: white;
  padding: 8px 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.info-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.info-item i {
  font-size: 18px;
  color: #667eea;
  margin-right: 12px;
  width: 20px;
  text-align: center;
}

.info-item .label {
  font-size: 14px;
  color: #909399;
  margin-right: 8px;
  min-width: 80px;
}

.info-item .value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.address-value {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.5;
  max-width: 200px;
  cursor: pointer;
}

.address-value.single-line {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

/* 标签页样式 */
.detail-tabs {
  border: none;
  box-shadow: none;
}

::v-deep .detail-tabs .el-tabs__header {
  margin: 0;
  background: #f5f7fa;
}

::v-deep .detail-tabs .el-tabs__content {
  padding: 0;
  height: 550px;
  overflow-y: auto;
}

::v-deep .detail-tabs .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tab-content {
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

::v-deep .detail-tabs .el-tabs__nav {
  border: none;
}

::v-deep .detail-tabs .el-tabs__item {
  border: none;
  padding: 0 20px;
  height: 500px;
  line-height: 50px;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s ease;
}

::v-deep .detail-tabs .el-tabs__item:hover {
  color: #667eea;
}

::v-deep .detail-tabs .el-tabs__item.is-active {
  color: #667eea;
  background: white;
  border-radius: 0;
  box-shadow: none;
}

.tab-content {
  padding: 0;
}

/* 概览页面样式 */
.overview-content {
  padding: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  max-width: 800px;
  margin: 0 auto;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e4e7ed;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.stat-icon i {
  font-size: 28px;
  color: white;
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  font-weight: 500;
}

/* 表格样式 */
.table-header {
  margin-bottom: 20px;
}

.table-header h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.table-desc {
  margin: 0;
  font-size: 14px;
  color: #909399;
}

.modern-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.modern-table th {
  font-weight: 600;
  color: #606266;
}

.amount {
  font-weight: 600;
  color: #f56c6c;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .shop-info-grid {
    grid-template-columns: 1fr;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  
  .shop-info-card {
    padding: 20px;
  }
  
  .tab-content {
    padding: 1px;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}

/* 动画效果 */
.shop-info-card {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card {
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}</style>



// WEBPACK FOOTER //
// src/views/shop/Index.vue